import React, { Component } from 'react';
import HotelLocations from 'components/widgets/autocompletes/hotelDestinations';
import DynamicDepartures from 'components/widgets/autocompletes/flightGateways';
import HotelOccupancy from 'components/widgets/hotelOccupancyShort';
import ErrorHandler from 'libraries/errorHandler';
import RangePicker from 'components/widgets/rangePickerNights';
import CustomRangePickerNights from 'components/widgets/customRangePickerNights';
import CustomDatePicker from 'components/widgets/customDatePicker';
import ErrorTooltip from 'components/snippets/errorTooltip';
import buildQueryString from 'helpers/buildQueryString';
import FlightTravellersTravelGenie from 'components/widgets/flightTravellersTravelGenie';
import Lang from 'libraries/Lang';
import moment from 'moment';
import AriaModal from 'react-aria-modal';
import FlightSearch from '../FlightSearch';
import HotelSearch from '../HotelSearch';
import CarSearch from '../CarSearch';
import LoadingModal from '../../../helpers/loadingModal';

class Dynamic extends Component {
    constructor(props) {
        super(props);
        const app = document.getElementById('app');
        const { language } = app.dataset;
        const agent = document.getElementById('AccountData').getAttribute('value');
        let agentData = null;
        if (agent !== '' && agent !== null) {
            agentData = JSON.parse(agent);
        }
        moment.locale(language);

        const stateValue = {
            selectedDestination: null,
            selectedDeparture: null,
            selectedProducts: 'FH',
            cabin: 'Y',
            depDate: null,
            retDate: null,
            depDateHotel: null,
            retDateHotel: null,
            occupancy: [{ adults: 2, children: 0, ages: [] }],
            occupancyOpen: false,
            shouldValidate: false,
            shouldValidateDepDate: false,
            shouldValidateRetDate: false,
            shouldValidateCustomDate: false,
            datePreset: 0,
            showPartStay: false,
            travellers: { adults: 2, children: 0, ages: [] },
            showTravellers: false,
            Traveltoken: props.Traveltoken,
            TravelRedirect: props.TravelRedirect,
            promoCode: '',
            checkInDate: null,
            checkOutDate: null,
            selectedAirline: null,
            noOfstop: 0,
            selectedDepartTime: null,
            departTime: null,
            selectedReturnTime: null,
            returnTime: null,
            eanData: null,
            destination: null,
            selectedHotel: null,
            selectedChain: null,
            errorList: {},
            selectedIncludeFreeBaggage: 'N',
            selectedExcludeOvernightConnections: 'N',
            selectedExcludeBasicEconomy: 'N',
            selectedExcludeNonRefundable: 'N',
            selectedExcludeNonChangable: 'N',
            activeTab: props.activeTab,
            commonDateFormat: props.commonDateFormat,
            flightSection: false,
            openFilters: false,
            hotelSection: false,
            carSection: false,
            carVendor: 'All',
            pickUpDate: null,
            dropOffDate: null,
            clearDepDateMsg: false,
            clearRetDateMsg: false,
            loadingModel: false,
            infantDetail: false,
            language: '',
            agentData: agentData,
        };

        const rules = {
            'form.departure': (departure) => {
                let valid = true;

                if (departure === null || Object.keys(departure).length === 0) {
                    valid = Lang.trans('engine_travelgenie.select_a_departure');
                }

                return valid;
            },

            'form.destination': (destination) => {
                let valid = true;

                if (destination === null || Object.keys(destination).length === 0) {
                    // valid = 'Select a destination';
                    valid = Lang.trans('engine_travelgenie.select_a_destination');
                }

                return valid;
            },
            'flightCar.childAge': (age, key, index) => {
                let valid = true;

                if (age == '') {
                    if(language == 'fr'){
                        valid = `Indiquez l’âge de l’enfant ${index + 1} dans la chambre`;
                        //  `child ${index + 1} in room ${key + 1} needs an age`;
                    }else{
                        valid = `child ${index + 1} needs an age`;
                    }
                }
                return valid;
            },
            'occupancy.childAge': (age, key, index) => {
                let valid = true;

                if (age === '') {
                    if(language == 'fr'){
                        valid = `Indiquez l’âge de l’enfant ${index + 1} dans la chambre ${key + 1}`;
                        //  `child ${index + 1} in room ${key + 1} needs an age`;
                    }else{
                        valid = `child ${index + 1} in room ${key + 1} needs an age`;
                    }
                }
                return valid;
            },
            'form.dates': (dates) => {
                let valid = true;
                // alert("ii")
                if (dates.depDate === null || dates.retDate === null
                    || !moment(dates.depDate, 'MM/DD/YYYY', true).isValid()
                    || !moment(dates.retDate, 'MM/DD/YYYY', true).isValid()
                    || !(moment(dates.depDate, 'MM/DD/YYYY').isSameOrAfter(moment().format('MM/DD/YYYY')))
                    || !(moment(dates.retDate, 'MM/DD/YYYY').isSameOrAfter(moment().format('MM/DD/YYYY')))

                ) {
                    // if (dates.depDate === null) {
                    // valid = 'Please select a valid departure and return date';
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_and_return_date');
                }
                
                if (!moment(dates.retDate).isAfter(dates.depDate)
                    && moment(dates.depDate, 'MM/DD/YYYY', true).isValid()
                    && moment(dates.retDate, 'MM/DD/YYYY', true).isValid()) {
                    // valid = 'Return date should be greater than departure date';
                    valid = Lang.trans('error.invalid_dates');
                }

                let today = moment();
                let maxDate = moment().add(11, 'months').subtract(6, 'days');
                if (!moment(dates.depDate, 'MM/DD/YYYY', true).isValid()
                    || !moment(dates.retDate, 'MM/DD/YYYY', true).isValid()
                    || !moment(dates.depDate, 'MM/DD/YYYY').isBetween(today, maxDate)
                    || !moment(dates.retDate, 'MM/DD/YYYY').isBetween(today, maxDate)   
                ) {
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_and_return_date');
                }

                if (agentData!== undefined && agentData !== null && agentData !== '' && agentData.CallCenterLogin !== undefined && agentData.CallCenterLogin !== 'Y') {
                    if (moment(dates.depDate, "YYYY-MM-DD", true).isValid() && 
                    new Date(moment().add(2, 'days').format("YYYY-MM-DD")).getTime() > new Date(moment(dates.depDate).format("YYYY-MM-DD")).getTime()
                    ) {       
                        valid = Lang.trans('engine_travelgenie.hrs_error_for_departure_date');
                    }
                }

                if (valid == true) {
                    this.errorHandler.clear('form.departureDate');
                    this.setState({ clearDepDateMsg: true });
                }

                return valid;
            },

            'form.departureDate': (depDate) => {
                let valid = true;

                if (depDate === null
                    || !moment(depDate, stateValue.commonDateFormat, true).isValid()
                    || !(moment(depDate, stateValue.commonDateFormat).isSameOrAfter(moment().format(stateValue.commonDateFormat)))
                ) {
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_and_return_date');
                }

                if (moment(depDate, stateValue.commonDateFormat, true).isValid()
                    && this.state.retDate != ''
                    && moment(this.state.retDate, stateValue.commonDateFormat, true).isValid()
                    && !moment(depDate, stateValue.commonDateFormat).isBefore(moment(this.state.retDate))) {
                    valid = Lang.trans('error.invalid_dates');
                }


                if (agentData!== undefined && agentData !== null && agentData !== '' && agentData.CallCenterLogin !== undefined && agentData.CallCenterLogin !== 'Y') {
                    if (moment(depDate, "YYYY-MM-DD", true).isValid() && 
                    new Date(moment().add(2, 'days').format("YYYY-MM-DD")).getTime() > new Date(moment(depDate).format("YYYY-MM-DD")).getTime()
                    ) {
                        valid = Lang.trans('engine_travelgenie.hrs_error_for_departure_date');
                    }
                }

                // if (valid == true) {
                //     this.errorHandler.clear('form.retDate');
                //     this.setState({ clearRetDateMsg: true });
                // }

                if (valid == true) {
                    this.setState({ shouldValidateDepDate: false });
                } else {
                    this.setState({ shouldValidateDepDate: true });
                }

                return valid;
            },

            'form.returnDate': (retDate) => {
                let valid = true;
                if (retDate === null
                    || !moment(retDate, stateValue.commonDateFormat, true).isValid()
                ) {
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_and_return_date');
                }
                if (moment(retDate, stateValue.commonDateFormat, true).isValid() && this.state.depDate != '' && moment(this.state.depDate, stateValue.commonDateFormat, true).isValid() && !moment(retDate, 'DD-MMM-YYYY').isAfter(moment(this.state.depDate))) {
                    valid = Lang.trans('error.invalid_dates');
                }

                if (valid == true) {
                    this.setState({ shouldValidateRetDate: false });
                } else {
                    this.setState({ shouldValidateRetDate: true });
                }

                return valid;
            },

            'form.hotelDates': (dates) => {
                let valid = true;
                if (!moment(dates.checkOutDate).isAfter(dates.checkInDate)
                    && moment(dates.checkInDate, 'MM/DD/YYYY', true).isValid()
                    && moment(dates.checkOutDate, 'MM/DD/YYYY', true).isValid()) {
                    valid = 'Checkout date should be greater than Checkin date';
                }
                return valid;
            },
            'form.checkInDate': (date) => {
                let valid = true;

                if (date != null && !moment(date, 'MM/DD/YYYY', true).isValid()) {
                    valid = 'Please select a valid Check In Date';
                }

                return valid;
            },

            'form.datesHotel': (dates) => {
                let valid = true;
                if (dates.depDateHotel === null || dates.retDateHotel === null) {
                    valid = 'Please selected a valid departure and return date';
                }
                return valid;
            },
        };
        this.errorHandler = new ErrorHandler(rules);

        const storage = localStorage.getItem('dynamicEngine');

        // try {
        //     if (storage !== null && storage.length > 0) {
        //         Object.assign(stateValue, JSON.parse(storage));

        //         if (stateValue.depDate !== null) {

        //             stateValue.depDate = moment(stateValue.depDate);
        //             if (stateValue.depDate.isBefore(moment())) {
        //                 stateValue.depDate = moment();
        //             }
        //         }

        //         if (stateValue.depDateHotel !== null) {
        //             stateValue.depDateHotel = moment(stateValue.depDateHotel);
        //             if (stateValue.depDateHotel.isBefore(moment())) {
        //                 stateValue.depDateHotel = moment();
        //             }
        //         }

        //         if (stateValue.retDate !== null) {
        //             stateValue.retDate = moment(stateValue.retDate);
        //             if (stateValue.retDate.isBefore(moment())) {
        //                 stateValue.retDate = moment().add(1, 'day');
        //             }
        //         }

        //         if (stateValue.retDateHotel !== null) {
        //             stateValue.retDateHotel = moment(stateValue.retDateHotel);
        //             if (stateValue.retDateHotel.isBefore(moment())) {
        //                 stateValue.retDateHotel = moment().add(1, 'day');
        //             }
        //         }
        //     }
        // } catch (e) {
        //     localStorage.removeItem('dynamicEngine');
        // }

        this.state = stateValue;

        this.selectDestination = this.selectDestination.bind(this);
        this.selectDeparture = this.selectDeparture.bind(this);
        this.selectProduct = this.selectProduct.bind(this);
        this.onDatesChange = this.onDatesChange.bind(this);
        this.onDatesChangeHotel = this.onDatesChangeHotel.bind(this);
        this.onOccupancyChange = this.onOccupancyChange.bind(this);
        this.setOccupancy = this.setOccupancy.bind(this);
        this.handleOccupancyBlur = this.handleOccupancyBlur.bind(this);
        this.onFareChange = this.onFareChange.bind(this);
        this.changePreset = this.changePreset.bind(this);
        this.submit = this.submit.bind(this);
        this.onCustomDatesChange = this.onCustomDatesChange.bind(this);
        this.onCustomNightChange = this.onCustomNightChange.bind(this);

        this.validateCustomDates = this.validateCustomDates.bind(this);

        this.toggleTravellers = this.toggleTravellers.bind(this);
        this.changeTravellers = this.changeTravellers.bind(this);
        this.handleTravellerBlur = this.handleTravellerBlur.bind(this);
        this.onPromoCodeChange = this.onPromoCodeChange.bind(this);
        this.selectIncludeFreeBaggage = this.selectIncludeFreeBaggage.bind(this);
        this.selectExcludeOvernightConnections = this.selectExcludeOvernightConnections.bind(this);
        this.selectExcludeBasicEconomy = this.selectExcludeBasicEconomy.bind(this);
        this.selectExcludeNonRefundable = this.selectExcludeNonRefundable.bind(this);
        this.selectExcludeNonChangable = this.selectExcludeNonChangable.bind(this);
        this.handleFlightSection = this.handleFlightSection.bind(this);
        this.handleHotelSection = this.handleHotelSection.bind(this);
        this.handleCarSection = this.handleCarSection.bind(this);
        this.showInfantDetail = this.showInfantDetail.bind(this);
        this.closeInfantDetail = this.closeInfantDetail.bind(this);
        this.clearFlightSelection = this.clearFlightSelection.bind(this);
        this.clearHotelSelection = this.clearHotelSelection.bind(this);
        this.clearCarSelection = this.clearCarSelection.bind(this);
        this.handleOpenFilters = this.handleOpenFilters.bind(this);
    }
    componentDidMount(){
        const app = document.getElementById('app');
        const { language } = app.dataset;
        this.setState({ language: language });
    }

    showInfantDetail() {
        this.setState({ infantDetail: true });
    }

    handleOpenFilters() {
        const { openFilters } = this.state;
        let value = false;
        value = openFilters !== true;
        this.setState({ openFilters: value });
    }

    closeInfantDetail() {
        this.setState({ infantDetail: false });
    }

    handleFlightSection() {
        const { flightSection } = this.state;
        let value = false;
        value = flightSection !== true;
        this.setState({ flightSection: value });
    }

    handleHotelSection() {
        const { hotelSection } = this.state;
        let value = false;
        value = hotelSection !== true;
        this.setState({ hotelSection: value });
    }

    handleCarSection() {
        const { carSection } = this.state;
        let value = false;
        value = carSection !== true;
        this.setState({ carSection: value });
    }

    clearFlightSelection() {
        this.setState({ 
            selectedAirline: null,
            noOfstop: 0,
            selectedDepartTime: null,
            departTime: null,
            selectedReturnTime: null,
            returnTime: null,
        });
    }

    clearHotelSelection() {
        this.setState({ 
            checkInDate: '',
            checkOutDate: '',
            eanData: null,
            selectedHotel: null,
            selectedChain: null,
        });
    }

    clearCarSelection() {
        this.setState({
            carVendor: 'All',
            pickUpDate: '',
            dropOffDate: '',
        });
    }

    selectIncludeFreeBaggage(event) {
        const { target } = event;

        if (event.target.checked === true) {
            this.setState({ selectedIncludeFreeBaggage: 'Y' });
        } else {
            this.setState({ selectedIncludeFreeBaggage: 'N' });
        }
    }

    selectExcludeOvernightConnections(event) {
        const { target } = event;

        if (event.target.checked === true) {
            this.setState({ selectedExcludeOvernightConnections: 'Y' });
        } else {
            this.setState({ selectedExcludeOvernightConnections: 'N' });
        }
    }

    selectExcludeBasicEconomy(event) {
        const { target } = event;

        if (event.target.checked === true) {
            this.setState({ selectedExcludeBasicEconomy: 'Y' });
        } else {
            this.setState({ selectedExcludeBasicEconomy: 'N' });
        }
    }

    selectExcludeNonRefundable(event) {
        const { target } = event;

        if (event.target.checked === true) {
            this.setState({ selectedExcludeNonRefundable: 'Y' });
        } else {
            this.setState({ selectedExcludeNonRefundable: 'N' });
        }
    }

    selectExcludeNonChangable(event) {
        const { target } = event;

        if (event.target.checked === true) {
            this.setState({ selectedExcludeNonChangable: 'Y' });
        } else {
            this.setState({ selectedExcludeNonChangable: 'N' });
        }
    }

    handleOccupancyBlur(event) {
        let node = event.target;
        let within = false;

        while (node !== event.currentTarget) {
            node = node.parentNode;

            if (node.classList.contains('htl_popover')) {
                within = true;
                break;
            }
        }

        if (!within) {
            this.hideOccupancy();
        }
    }

    onPromoCodeChange(event) {
        this.setState({ promoCode: event.target.value });
    }

    onDatesChange(depDate, retDate) {
        const { shouldValidate, shouldValidateDepDate, shouldValidateRetDate } = this.state;
        if (shouldValidate) {
            // this.errorHandler.checkRule('form.dates', { depDate, retDate });
            this.errorHandler.clear('form.dates');
        } else {
            this.errorHandler.checkRule('form.dates', { depDate, retDate });
        }
        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.departureDate');
        } else {
            this.errorHandler.checkRule('form.departureDate', depDate);
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.returnDate');
        } else {
            this.errorHandler.checkRule('form.returnDate', retDate);
        }
        // alert(depDate)
        this.setState({
            depDate, retDate, checkInDate: depDate, checkOutDate: retDate, pickUpDate: depDate, dropOffDate: retDate,
        });
    }

    validateCustomDates(name, depDate) {
        const {
            shouldValidate, commonDateFormat, shouldValidateDepDate, shouldValidateRetDate,
        } = this.state;
        this.errorHandler.clear('form.dates');
        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.departureDate');
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.returnDate');
        }
        if (name == 'depDate' && depDate != '') {
            this.errorHandler.checkRule('form.departureDate', depDate);
        }
        if (depDate != '' && name == 'retDate') {
            this.errorHandler.checkRule('form.returnDate', depDate);
        }
        this.setState({ shouldValidateCustomDate: true });
    }

    onCustomDatesChange(name, depDate) {
        
        const dateMonth = depDate.replace(/[0-9]/g, '').toLowerCase();
        let updatedDate = depDate;
        const { language } = app.dataset;

        if (language == 'fr') {
            let lowerCaseDate = depDate.toLowerCase();
            if (dateMonth == 'jan') {
                updatedDate =  lowerCaseDate.replace('jan', 'janv');
            } else if (dateMonth == 'fev') {
                updatedDate =  lowerCaseDate.replace('fev', 'févr.');
            } else if (dateMonth == 'mar') {
                updatedDate =  lowerCaseDate.replace('mar', 'mars');
            } else if (dateMonth == 'avr') {
                updatedDate =  lowerCaseDate.replace('avr', 'avr.');
            } else if (dateMonth == 'mai') {
                updatedDate =  lowerCaseDate.replace('mai', 'mai');
            } else if (dateMonth == 'jun') {
                updatedDate =  lowerCaseDate.replace('jun', 'juin');
            } else if (dateMonth == 'jul') {
                updatedDate =  lowerCaseDate.replace('jul', 'juil');
            }  else if (dateMonth == 'aou') {
                updatedDate =  lowerCaseDate.replace('aou', 'août');
            }  else if (dateMonth == 'sep') {
                updatedDate =  lowerCaseDate.replace('sep', 'sept');
            }  else if (dateMonth == 'oct') {
                updatedDate =  lowerCaseDate.replace('oct', 'oct.');
            }  else if (dateMonth == 'nov') {
                updatedDate =  lowerCaseDate.replace('nov', 'nov.');
            }  else if (dateMonth == 'dec') {
                updatedDate =  lowerCaseDate.replace('dec', 'déc.');
            }  
        }

        const {
            shouldValidate, commonDateFormat, shouldValidateDepDate, shouldValidateRetDate,
        } = this.state;

        const val = updatedDate.substring(0, 2);
        updatedDate = moment(updatedDate, commonDateFormat, true).isValid() ? moment(updatedDate, 'DD-MMM-YYYY') : updatedDate;

        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.departureDate');
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.returnDate');

        }

        this.setState({ [name]: updatedDate }, () => {
            const { depDate, retDate } = this.state;
            this.errorHandler.checkRule('form.dates', { depDate, retDate });
            if (name == 'depDate') {
                this.setState({ checkInDate: updatedDate, pickUpDate: updatedDate });
            } if (name == 'retDate') {
                this.setState({ checkOutDate: updatedDate, dropOffDate: updatedDate });
            }
        });
        
    }

    onCustomNightChange(days) {
        const { shouldValidate, shouldValidateDepDate, shouldValidateRetDate } = this.state;
        // if (shouldValidate) {
        //     this.errorHandler.checkRule('form.dates', { depDate });
        //     this.errorHandler.clear('form.dates');
        // }
        // alert(moment(depDate, 'MM/DD/YYYY', true).isValid()+"##")

        const { depDate } = this.state;
        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.departureDate');
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.returnDate');
        }
        let retDate = '';
        if (days != '' && days != 0) {
            retDate = moment(depDate, 'MM/DD/YYYY').add(days, 'days');
        } else {
            retDate = '';
        }

        this.setState({
            retDate, checkOutDate: retDate, dropOffDate: retDate }, () => {
            if (depDate != '') {
                this.errorHandler.checkRule('form.departureDate', depDate);
            }
            if (retDate != '') {
                this.errorHandler.checkRule('form.returnDate', retDate);
            }
            if (depDate != '' && retDate != '') {
                this.errorHandler.checkRule('form.dates', { depDate, retDate });
            }
        });
        // this.setState({ retDate: retDate, checkOutDate: retDate });
    }

    onDatesChangeHotel(depDateHotel, retDateHotel) {
        const { shouldValidate } = this.state;
        if (shouldValidate) {
            // this.errorHandler.checkRule('form.datesHotel', { depDateHotel, retDateHotel });
            this.errorHandler.clear('form.datesHotel');
        }
        this.setState({ depDateHotel, retDateHotel });
    }

    onOccupancyChange(occupancy, paramter) {
        const [room, field, index] = paramter.split('-');
        const { occupancy: currentOccupancy } = this.state;

        if (field === 'children' && currentOccupancy[parseInt(room, 10)].children > occupancy[parseInt(room, 10)].children) {
            for (let i = currentOccupancy[parseInt(room, 10)].children; i > occupancy[parseInt(room, 10)].children; i--) {
                this.errorHandler.clear(`occupancy-${room}.childAge-${i - 1}`);
            }
        }

        if (field === 'rooms' && currentOccupancy.length > occupancy.length) {
            for (let i = currentOccupancy.length, { length } = occupancy; i > length; i--) {
                this.errorHandler.clear(`occupancy-${i - 1}`);
            }
        }

        const { shouldValidate } = this.state;
        if (shouldValidate && field === 'childAge') {
            this.errorHandler.checkRule(`occupancy-${room}.childAge-${index}`, occupancy[room].ages[index]);
        }
        this.setState({ occupancy });
    }

    onFareChange(event) {
        const { value } = event.target;

        this.setState({ cabin: value });
    }

    setOccupancy(occupancyOpen) {
        if (occupancyOpen) {
            this.showOccupancy();
        } else {
            this.hideOccupancy();
        }
    }

    hideOccupancy() {
        const app = document.getElementById('page');
        app.removeEventListener('click', this.handleOccupancyBlur);

        this.setState({ occupancyOpen: false });
    }

    showOccupancy() {
        const app = document.getElementById('page');
        app.addEventListener('click', this.handleOccupancyBlur);

        this.setState({ occupancyOpen: true });
    }

    selectDeparture(selectedDeparture) {
        const { shouldValidate } = this.state;
        if (shouldValidate) {
            this.errorHandler.checkRule('form.departure', selectedDeparture);
        }
        this.setState({ selectedDeparture });
    }

    selectDestination(selectedDestination) {
        const { shouldValidate } = this.state;
        if (shouldValidate) {
            // this.errorHandler.checkRule('form.destination', selectedDestination);
            this.errorHandler.clear('form.destination');
        }
        this.setState({ selectedDestination, eanData: null, selectedHotel: null, selectedChain: null });
    }

    selectProduct(event) {
        const { target } = event;

        this.setState({ selectedProducts: target.value });
    }

    changePreset(datePreset) {
        this.setState({ datePreset });
    }

    changePartStay(event) {
        const { showPartStay } = this.state;

        this.setState({ showPartStay: !showPartStay });
    }

    handleTravellerBlur(event) {
        let node = event.target;

        let within = false;

        while (node !== event.currentTarget) {
            node = node.parentNode;

            if (node.classList.contains('htl_popover')) {
                within = true;
                break;
            }
        }

        if (!within) {
            this.hideTravellers();
        }
    }

    toggleTravellers(occupancyOpen) {
        if (occupancyOpen) {
            this.showTravellers();
        } else {
            this.hideTravellers();
        }
    }

    hideTravellers() {
        const app = document.getElementById('page');
        app.removeEventListener('click', this.handleTravellerBlur);

        this.setState({ showTravellers: false });
    }

    showTravellers() {
        const app = document.getElementById('page');
        app.addEventListener('click', this.handleTravellerBlur);

        this.setState({ showTravellers: true });
    }

    changeTravellers(travellers) {
        if (travellers && travellers !== null && travellers !== undefined && travellers.children && travellers.children > 0 && travellers.ages && travellers.ages.length > 0) {
            travellers.ages.forEach((age, index) => {
                this.errorHandler.checkRule(`flightCar.childAge-${index}`, travellers.ages[index]);
            });
        }
        this.setState({ travellers });
    }

    setSearchParameter = (field, value) => {
        this.setState((prevState) => {
            const searchBundleArray = Object.assign({}, prevState); // creating copy of state variable jsonper
            searchBundleArray[field] = value; // update the name property, assign a new value
            return searchBundleArray; // return new object jsonper object
        });
    }

    submit(event) {
        const {
            occupancy,
            selectedDestination,
            selectedDeparture,
            cabin,
            depDate,
            retDate,
            depDateHotel,
            retDateHotel,
            selectedProducts,
            showPartStay,
            travellers,
            Traveltoken,
            TravelRedirect,
            promoCode,
            checkInDate,
            checkOutDate,
            selectedHotel,
            selectedChain,
            selectedAirline,
            noOfstop,
            departTime,
            returnTime,
            eanData,
            selectedIncludeFreeBaggage,
            selectedExcludeOvernightConnections,
            selectedExcludeBasicEconomy,
            selectedExcludeNonRefundable,
            selectedExcludeNonChangable,
            pickUpDate,
            dropOffDate,
            carVendor,
            language,
        } = this.state;

        this.errorHandler.checkRule('form.departure', selectedDeparture);
        this.errorHandler.checkRule('form.destination', selectedDestination);
        this.errorHandler.checkRule('form.dates', { depDate, retDate });
        this.errorHandler.checkRule('form.hotelDates', { checkInDate, checkOutDate });
        this.errorHandler.checkRule('form.checkInDate', checkInDate);

        if (showPartStay) {
            this.errorHandler.checkRule('form.datesHotel', { depDateHotel, retDateHotel });
        } else {
            // let disableValid = moment();
            // this.errorHandler.checkRule('form.datesHotel', { disableValid,  disableValid });
            this.errorHandler.clear('form.datesHotel');
        }

        occupancy.forEach((room, key) => {
            room.ages.forEach((age, index) => {
                this.errorHandler.checkRule(`occupancy-${key}.childAge-${index}`, occupancy[key].ages[index]);
            });
        });

        if (travellers && travellers !== null && travellers !== undefined && travellers.children && travellers.children > 0 && travellers.ages && travellers.ages.length > 0) {
            travellers.ages.forEach((age, index) => {
                this.errorHandler.checkRule(`flightCar.childAge-${index}`, travellers.ages[index]);
            });
        }

        const errors = this.errorHandler.getErrors();
        this.setState({ errorList: this.errorHandler.getErrors() });

        if (Object.keys(errors).length > 0) {
            event.preventDefault();
            this.setState({ shouldValidate: true });
        } else {
            this.setState({ loadingModel : true });
            const agent = document.getElementById('AccountData').getAttribute('value');
            let agentData = null;
            if (agent !== '' && agent !== null) {
                agentData = JSON.parse(agent);
            }
            event.preventDefault();

            const bundles = {};
            const params = {};

            params.occupancy = (selectedProducts == 'FH') ? occupancy : [travellers];

            params.depDate = depDate !== null ? depDate.format('YYYY-MM-DD') : '',
            params.retDate = retDate !== null ? retDate.format('YYYY-MM-DD') : '',
            params.checkInDate = checkInDate !== null ? checkInDate.format('YYYY-MM-DD') : '',
            params.checkOutDate = checkOutDate !== null ? checkOutDate.format('YYYY-MM-DD') : '',
            params.destination = Object.assign({}, selectedDestination);
            params.departure = selectedDeparture;
            params.cabinType = cabin;
            params.trip = 'roundtrip';
            params.selectedProducts = selectedProducts;
            params.actualSelectedProducts = selectedProducts;

            if(params.destination.text && params.destination.text !== undefined && params.destination.text !== null){
                params.destination.text = encodeURIComponent(params.destination.text);
            }
            if(params.destination.city && params.destination.city !== undefined && params.destination.city !== null){
                params.destination.city = encodeURIComponent(params.destination.city);
            }

            // flight section
            const airlinesValue = [];
            if (selectedAirline && selectedAirline !== null && selectedAirline.length > 0) {
                selectedAirline.map((item) => {
                    airlinesValue.push(item.value);
                });
            }
            params.airlines = selectedAirline ? airlinesValue : [];
            params.selectedAirline = selectedAirline || '';
            params.noOfStops = noOfstop != null ? noOfstop : '';

            params.departTime = departTime != null ? moment(departTime, ['h:mm A']).format('HH:mm') : '';
            params.returnTime = returnTime != null ? moment(returnTime, ['h:mm A']).format('HH:mm') : '';

            // hotel section
            if (selectedProducts == 'FH') {
                const selectedSearchHotel = Object.assign({}, selectedHotel);
                if (selectedSearchHotel !== undefined && selectedSearchHotel !== null) {
                    if (selectedSearchHotel.text !== undefined && selectedSearchHotel.text !== null) {
                        selectedSearchHotel.text = encodeURIComponent(selectedSearchHotel.text);
                    }
                    if (selectedSearchHotel.text2 !== undefined && selectedSearchHotel.text2 !== null) {
                        selectedSearchHotel.text2 = encodeURIComponent(selectedSearchHotel.text2);
                    }
                    if (selectedSearchHotel.value !== undefined && selectedSearchHotel.value !== null) {
                        selectedSearchHotel.value = encodeURIComponent(selectedSearchHotel.value);
                    }
                }

                params.selectedHotel = selectedSearchHotel;
                params.selectedChain = selectedChain;
                params.chainName = (selectedChain != null && selectedChain.value) ? selectedChain.value : '', 
                params.eanHotelIds = eanData?.eanHotelIds != null ? eanData.eanHotelIds : [];
                params.pricelineHotelIds = eanData?.pricelineHotelIds != null ? eanData.pricelineHotelIds : [];
                params.tbiHotelIds = eanData?.tbiHotelIds != null ? eanData.tbiHotelIds : [];
            }
            bundles.searchType = 'travelgenie';

            params.isAdvance = eanData?.eanHotelIds != null;

            params.includeFreeBaggage = selectedIncludeFreeBaggage;
            params.excludeOvernightConnections = selectedExcludeOvernightConnections;
            params.excludeBasicEconomy = selectedExcludeBasicEconomy;
            params.excludeNonRefundable = selectedExcludeNonRefundable;
            params.excludeNonChangable = selectedExcludeNonChangable;

            params.pickUpDate = (pickUpDate !== null && selectedProducts == 'FC') ? pickUpDate.format('YYYY-MM-DD') : '',
            params.dropOffDate = (dropOffDate !== null && selectedProducts == 'FC') ? dropOffDate.format('YYYY-MM-DD') : '',
            params.carVendor = (selectedProducts == 'FC' && carVendor != null) ? carVendor : 'All';

            bundles.bundles = [{ ...params }];

            // bundles.refundable = "1";
            bundles.lang = window.Locale;
            // bundles.currency = "USD";
            bundles.affiliate = 'redtag';
            bundles.promoCode = promoCode;

            let chainId = '';
            let agentId = '';
            let agencyId = '';
            let organizationId = '';
            let agentLogin = '';
            let agentFirstName = '';
            let agentLastName = '';
            let newBooking = null;

            if (agentData !== '' && agentData !== null) {
                chainId = typeof agentData.Chain !== 'undefined' && agentData.Chain !== null && agentData.Chain !== '' ? agentData.Chain.code : '';
                agencyId = typeof agentData.Agency !== 'undefined' && agentData.Agency.phone !== null && agentData.Agency.phone !== '' ? agentData.Agency.phone : '';
                // agentId = typeof agentData.TtsId !== 'undefined' && agentData.TtsId !== null && agentData.TtsId !== '' ? agentData.TtsId : '';
                agentId = typeof agentData.AgentId !== 'undefined' && agentData.AgentId !== null && agentData.AgentId !== '' ? agentData.AgentId : '';
                organizationId = typeof agentData.OrganizationId !== 'undefined' && agentData.OrganizationId !== null && agentData.OrganizationId !== '' ? agentData.OrganizationId : '';
                agentLogin = typeof agentData.Names.username !== 'undefined' && agentData.Names.username !== null && agentData.Names.username !== '' ? agentData.Names.username : '';
                agentFirstName = typeof agentData.Names.first !== 'undefined' && agentData.Names.first !== null && agentData.Names.first !== '' ? agentData.Names.first : '';
                agentLastName = typeof agentData.Names.last !== 'undefined' && agentData.Names.last !== null && agentData.Names.last !== '' ? agentData.Names.last : '';
                newBooking = (agentData.newBooking && agentData.newBooking == true) ? true : null;
            }
            bundles.chainId = chainId;
            bundles.agentId = agentId;
            bundles.agencyId = agencyId;
            bundles.organizationId = organizationId;
            bundles.agentLogin = agentLogin;
            bundles.agentFirstName = agentFirstName;
            bundles.agentLastName = agentLastName;
            bundles.localeLang = language;

            if (agentData.CallCenterLogin === 'Y') {
                bundles.rezAgentUserId = agentData.CallCenterUserName;
            }

            const queryString = JSON.stringify(bundles);

            const encodeUrl = encodeURI(queryString);

            const url = `${TravelRedirect}/create?t=${Traveltoken}&localeLang=${language}&request=${encodeUrl}${newBooking == true ? '&newBooking=true' : ''}`;

            window.location.href = url;

            const storage = {
                selectedDestination,
                selectedDeparture,
                cabin,
                depDate,
                retDate,
                selectedProducts,
                depDateHotel,
                retDateHotel,
                occupancy,
            };

            // localStorage.setItem('dynamicEngine', JSON.stringify(storage));

            // const url = TravelRedirect+"/?t=" + Traveltoken;
            // window.location.href = url;
        }
    }

    render() {
        const {
            selectedDestination,
            selectedDeparture,
            depDate,
            retDate,
            depDateHotel,
            retDateHotel,
            occupancy,
            occupancyOpen,
            cabin,
            selectedProducts,
            datePreset,
            showPartStay,
            Traveltoken,
            TravelRedirect,
            noOfNights,
            travellers,
            showTravellers,
            promoCode,
            selectedIncludeFreeBaggage,
            selectedExcludeOvernightConnections,
            selectedExcludeBasicEconomy,
            selectedExcludeNonRefundable,
            selectedExcludeNonChangable,
            activeTab,
            commonDateFormat,
            flightSection,
            hotelSection,
            carSection,
            shouldValidateDepDate,
            shouldValidateRetDate,
            loadingModel,
            infantDetail,
            language,
            openFilters,
            agentData
        } = this.state;

        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.departureDate');
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.returnDate');
        }
        // let customDepDate = (depDate !== null && moment(depDate, 'MM/DD/YYYY', true).isValid()) ? depDate.format('YYYY/MM/DD') : depDate
        // let customRetDate= (retDate !== null && moment(retDate, 'MM/DD/YYYY', true).isValid()) ? retDate.format('YYYY/MM/DD') : retDate
        // let noOfNights = (moment(depDate, 'MM/DD/YYYY', true).isValid() && moment(retDate, 'MM/DD/YYYY', true).isValid()) ? retDate.diff(depDate, 'days') : 0

        const isDepDatevalid = moment(depDate, commonDateFormat, true).isValid();
        const isRetDatevalid = moment(retDate, commonDateFormat, true).isValid();

        const errors = this.errorHandler.getErrors();

        const request = {
            occupancy,
            depDate: (depDate !== null && moment(depDate, 'YYYY-MM-DD', true).isValid()) ? depDate.format('YYYY-MM-DD') : '',
            retDate: (retDate !== null && moment(retDate, 'YYYY-MM-DD', true).isValid()) ? retDate.format('YYYY-MM-DD') : '',
            depDateHotel: depDateHotel !== null ? depDateHotel.format('YYYY-MM-DD') : '',
            retDateHotel: retDateHotel !== null ? retDateHotel.format('YYYY-MM-DD') : '',
            destination: selectedDestination,
            departure: selectedDeparture,
            cabinType: cabin,
            trip: 'roundtrip',
            selectedProducts,
            selectedIncludeFreeBaggage,
            selectedExcludeOvernightConnections,
            selectedExcludeBasicEconomy,
            selectedExcludeNonRefundable,
            selectedExcludeNonChangable,
            lang: 'en',
        };

        const calendarInfo = {
            options: [
                { text: 'Exact Dates', value: 0 },
                { text: '±3 Days', value: 3 },
            ],
            onChange: this.changePreset,
            selected: datePreset,
            subText: 'all travel times are in local time',
        };

        const agentAccount = document.getElementById('AccountData').getAttribute('value');
        let agentDetail = null;
        if (agentAccount !== '' && agentAccount !== null) {
            agentDetail = JSON.parse(agentAccount);
        }

        let minDate = 0;
        if(agentData!== undefined && agentData !== null && agentData !== '' && agentData.CallCenterLogin !== undefined && agentData.CallCenterLogin !== 'Y'){
            minDate = 2;
        }

        return (
            <>
                <LoadingModal isLoading={loadingModel} /> 
                <form className="search-travelgenie hotel-flight-horizontal-search" onSubmit={this.submit}>
                    <input type="hidden" name="request" value={JSON.stringify(request)} />
                    <div className="row gutter-10 mb-1">
                        <div className="col-6 text-left">
                            <div className="styled-radio black-text mb-2">
                                <input type="radio" id="radio-flight+hotel" name="trip" value="FH" onChange={this.selectProduct} checked={selectedProducts === 'FH'} />
                                <label htmlFor="radio-flight+hotel">
                                    <span>{Lang.trans('engine_travelgenie.flight_hotel')}</span>
                                </label>
                            </div>
                            {/* <div className="styled-radio black-text">
                            <input type="radio" id="radio-hotel+car" name="trip" value="HC" onChange={this.selectProduct} checked={selectedProducts === 'HC'} />
                            <label htmlFor="radio-hotel+car">
                                <span>Hotel + Car</span>
                            </label>
                        </div>
                        <div className="styled-radio black-text">
                            <input type="radio" id="radio-flight+hotel+car" name="trip" value="FHC" onChange={this.selectProduct} checked={selectedProducts === 'FHC'} />
                            <label htmlFor="radio-flight+hotel+car">
                                <span>Flight + Hotel + Car</span>
                            </label>
                        </div> */}
                            <div className="styled-radio black-text mb-2">
                                <input type="radio" id="radio-flight+car" name="trip" value="FC" onChange={this.selectProduct} checked={selectedProducts === 'FC'} />
                                <label htmlFor="radio-flight+car">
                                    <span>{Lang.trans('engine_travelgenie.flight_car')}</span>
                                </label>
                            </div>
                        </div>

                        <div className="col-6 text-right">
                            <a href={`${TravelRedirect}/multi-destination?t=${Traveltoken}&localeLang=${language}&from=tg${agentDetail !== null && agentDetail.newBooking && agentDetail.newBooking == true ? '&newBooking=true' : ''}`} type="" className="col-6 col-md-5 text-underline">
                                <span className="">{Lang.trans('engine.multipleDestination')}</span>
                            </a>
                        </div>
                    </div>
                    <div className="row gutter-10">
                        <div className="col-12 col-md-12 col-lg-6 going-to">

                            <div className="row gutter-10">
                                <div className="col-12 col-sm-6">
                                    <div className="element-container">
                                        <label className="text-label" htmlFor="dyn_departure">{Lang.trans('engine_travelgenie.from')}</label>
                                        <div className="element-wrapper">
                                            <DynamicDepartures
                                                id="dyn_departure"
                                                placeholder={Lang.trans('engine_travelgenie.departure_placeholder')}
                                                onSelect={this.selectDeparture}
                                                value={selectedDeparture}
                                            />
                                            {errors.form && errors.form.departure && (
                                                <ErrorTooltip error={{ message: errors.form.departure, id: 'departure' }} />
                                            )}
                                        </div>
                                        <button type="button" className="remove-focus-btn" tabIndex="-1" />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6">
                                    {/* <button type="button" className="btn-unstyled btn-switch border">
                                        <div className="icon-container">
                                          <svg className="icon mt-xl-1 primary-color" width="100%" height="100%" xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <use xlinkHref="/img/icons/icon-defs.svg#icon-half-right-left-arrow"></use>
                                          </svg>
                                        </div>
                                    </button>  */}
                                    <div className="">
                                        <div className="element-container">
                                            <label className="text-label" htmlFor="dyn_destination">{Lang.trans('engine_travelgenie.to')}</label>
                                            <div className="element-wrapper">
                                                <HotelLocations
                                                    id="dyn_destination"
                                                    placeholder={Lang.trans('engine_travelgenie.departure_placeholder')}
                                                    onSelect={this.selectDestination}
                                                    value={selectedDestination}
                                                    travelgenie="Y"
                                                />
                                                {errors.form && errors.form.destination && (
                                                    <ErrorTooltip error={{ message: errors.form.destination, id: 'destination' }} />
                                                )}
                                            </div>
                                        </div>
                                        <button type="button" className="remove-focus-btn" tabIndex="-1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-6 duration">

                            <div className="element-container range-picker-container">

                                {/*
                            <CustomDatePicker
                                dateId="flt_departureDate"
                                minDate={1}
                                label="Departure"
                                datePlaceholderText="Select Date"
                                //date={depDate}
                                depDate={customdepDate}
                                // onDatesChange={this.onDatesChange}
                                onCustomDatesChange={this.onCustomDatesChange}
                                onDateChange={this.onDatesChange}
                            //startDate={depDate}                                        // onDateChange={(date) => { onDateChange(date, `date-${leg.key}`); }}
                            /> */}

                                <CustomRangePickerNights
                                    startDateId="dyn_departureDate"
                                    endDateId="dyn_returnDate"
                                    onDatesChange={this.onDatesChange}
                                    onCustomDatesChange={this.onCustomDatesChange}
                                    validateCustomDates={this.validateCustomDates}
                                    onCustomNightChange={this.onCustomNightChange}
                                    minDate={minDate}
                                    noOfNights={noOfNights}
                                    startDatePlaceholderText={Lang.trans('engine.date_format')}
                                    endDatePlaceholderText={Lang.trans('engine.date_format')}
                                    startDate={depDate}
                                    endDate={retDate}
                                    isDepDatevalid={isDepDatevalid}
                                    isRetDatevalid={isRetDatevalid}
                                    activeTab={activeTab}
                                    dateFormat={commonDateFormat}
                                />

                                {errors.form && errors.form.departureDate && (
                                    <ErrorTooltip error={{ message: errors.form.departureDate, id: 'departureDate' }} />
                                )}
                                {errors.form && errors.form.returnDate && (
                                    <ErrorTooltip error={{ message: errors.form.returnDate, id: 'returnDate' }} />
                                )}

                                {errors.form && errors.form.dates && (
                                    <ErrorTooltip error={{ message: errors.form.dates, id: 'dates' }} />
                                )}
                            </div>
                        </div>

                        <div className="col-12 col-md-12 col-lg-6 col-xxl-3 cabin-rooms">
                            <div className="element-container">
                                <div className="row gutter-0">
                                    <div className="col">
                                        <div className="select-unstyled-container">
                                            <label className="text-label">{Lang.trans('engine_travelgenie.cabin')}</label>
                                            <select className="w-100 select-unstyled" id="cruise_duration" value={cabin} onChange={this.onFareChange}>
                                                <option value="Y">{Lang.trans('engine_flights.class_economy')}</option>
                                                <option value="S">{Lang.trans('engine_flights.class_premium_economy')}</option>
                                                <option value="C">{Lang.trans('engine_flights.class_business')}</option>
                                                <option value="F">{Lang.trans('engine_flights.class_first')}</option>
                                            </select>
                                            <svg className="icon icon-select" aria-hidden="true">
                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                                            </svg>
                                        </div>
                                    </div>

                                    <div className="col">
                                    
                                        {selectedProducts == 'FH' ? (
                                            <HotelOccupancy
                                                visible={occupancyOpen}
                                                occupancy={occupancy}
                                                errors={errors}
                                                validateField={() => { }}
                                                onChange={this.onOccupancyChange}
                                                onVisibilityChange={this.setOccupancy}
                                                fromFH={true}
                                            />
                                        ) : (
                                            <FlightTravellersTravelGenie
                                                travellers={travellers}
                                                onChange={this.changeTravellers}
                                                errors={errors}
                                                visible={showTravellers}
                                                onVisibilityChange={this.toggleTravellers}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(showPartStay) && (
                            <div className="col-12 col-md-12 col-lg-6 duration-return">
                                <div className="element-container range-picker-container">
                               
                                    <RangePicker
                                        startDateId="dyn_departureDate"
                                        endDateId="dyn_returnDate"
                                        onDatesChange={this.onDatesChangeHotel}
                                        minDate={minDate}
                                        startDatePlaceholderText="Start Date"
                                        endDatePlaceholderText="End Date"
                                        startDate={depDateHotel}
                                        endDate={retDateHotel}
                                    //  calendarInfo={calendarInfo}
                                    />
                                    {errors.form && errors.form.datesHotel && (
                                        <ErrorTooltip error={{ message: errors.form.datesHotel, id: 'datesHotel' }} />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="mb-0">
                    <a onClick={this.handleOpenFilters} class="text-underline d-inline-block mt-3 mb-3" role="button"> {Lang.trans('engine.filters')}
                        <svg class="icon-sm primary-color ml-2">        
                            <use xmlns="http://www.w3.org/2000/svg" xlinkHref={`/img/icons/icon-defs.svg#${openFilters ? 'icon-chevron-up' : 'icon-chevron-down-lihgt'}`} />
                        </svg>
                    </a>
                    <div className="text-right d-flex align-items-center float-right ">
                        <svg className="icon primary-color mr-1">
                            <use xmlns="http://www.w3.org/2000/svg" xlinkHref="/img/icons/icon-defs.svg#icon-info-circle" />
                        </svg>
                        <a href="javascript:;" onClick={this.showInfantDetail}>
                        {Lang.trans('engine_travelgenie.booking_an_infant')}
                        </a>
                    </div>
                    </div>
                    {openFilters == true ?
                    <>
                        <div className="mb-2 d-flex justify-content-between">
                            <a onClick={this.handleFlightSection} type="" role="button">
                                <span className="mr-2 text-underline primary-color">{Lang.trans('engine.additionalFlightFilter')}</span>
                                <svg className="icon-sm primary-color">
                                    <use xmlns="http://www.w3.org/2000/svg" xlinkHref={`/img/icons/icon-defs.svg#${flightSection ? 'icon-chevron-up' : 'icon-chevron-down-lihgt'}`} />
                                </svg>
                            </a>
                            {flightSection && (
                                <a onClick={this.clearFlightSelection} type="" role="button">
                                        <span className="mr-2 text-underline primary-color">{Lang.trans('engine.clear')}</span>
                                </a>
                             )}
                        </div>
                  
                    {flightSection && (
                        <>
                            <FlightSearch flightData={this.state} setSearchParameter={this.setSearchParameter} />
                           
                        </>
                    )}
                    {selectedProducts == 'FH'
                        ? (
                            <>
                                <div className="mb-2 d-flex justify-content-between">
                                    <a onClick={this.handleHotelSection} type="" role="button">
                                        <span className="mr-2 text-underline primary-color">{Lang.trans('engine.additionalHotelFilter')}</span>
                                        <svg className="icon-sm primary-color">
                                            <use xmlns="http://www.w3.org/2000/svg" xlinkHref={`/img/icons/icon-defs.svg#${hotelSection ? 'icon-chevron-up' : 'icon-chevron-down-lihgt'}`} />
                                        </svg>
                                    </a>
                                    {hotelSection && (
                                        <a onClick={this.clearHotelSelection} type="" role="button">
                                            <span className="mr-2 text-underline primary-color">{Lang.trans('engine.clear')}</span>
                                        </a>
                                    )}
                                </div>
                                {hotelSection && (
                                    <>
                                        <HotelSearch hotelData={this.state} errorHandler={this.errorHandler} errors={errors} setSearchParameter={this.setSearchParameter} activeTab={activeTab} commonDateFormat={commonDateFormat} />
                                       
                                    </>
                                )}
                            </>
                        )
                        : null}

                    {selectedProducts == 'FC'
                        ? (
                            <>
                                <div className="mb-2 d-flex justify-content-between">
                                    <a onClick={this.handleCarSection} type="" role="button">
                                        <span className="mr-2 text-underline primary-color">{Lang.trans('engine.additionalCarFilter')}</span>
                                        <svg className="icon-sm primary-color">
                                            <use xmlns="http://www.w3.org/2000/svg" xlinkHref={`/img/icons/icon-defs.svg#${carSection ? 'icon-chevron-up' : 'icon-chevron-down-lihgt'}`} />
                                        </svg>
                                    </a>
                                    {carSection && (
                                        <a onClick={this.clearCarSelection} type="" role="button">
                                            <span className="mr-2 text-underline primary-color">{Lang.trans('engine.clear')}</span>
                                        </a>
                                     )}
                                </div>
                                {carSection && (
                                    <>
                                        <CarSearch hotelData={this.state} errorHandler={this.errorHandler} errors={errors} setSearchParameter={this.setSearchParameter} activeTab={activeTab} commonDateFormat={commonDateFormat} />
                                        
                                    </>
                                )}
                            </>
                        )
                        : null}
                    </>
                    : '' }
                    {/* {selectedProducts !== 'H' && selectedProducts !== 'HC' && selectedProducts !== 'M' && selectedProducts !== 'V' && (
                    <div className="row gutter-10 mb-3">
                        <div className="col-auto">
                            <div className="styled-checkbox py-1" d-flex="true">
                                <input
                                    type="checkbox"
                                    id="include-free-baggage"
                                    value="Y"
                                    name="include-free-baggage"
                                    checked={selectedIncludeFreeBaggage === 'Y'}
                                    onChange={this.selectIncludeFreeBaggage}
                                />
                                <label htmlFor="include-free-baggage">
                                    <span className="d-block">&nbsp;{Lang.trans('engine.include_baggage')}</span>
                                </label>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="styled-checkbox py-1" d-flex="true">
                                <input
                                    type="checkbox"
                                    id="exclude-overnight-connections"
                                    value="Y"
                                    name="exclude-overnight-connections"
                                    checked={selectedExcludeOvernightConnections === 'Y'}
                                    onChange={this.selectExcludeOvernightConnections}
                                />
                                <label htmlFor="exclude-overnight-connections">
                                    <span className="d-block">&nbsp;{Lang.trans('engine.exclude_connections')}</span>
                                </label>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="styled-checkbox py-1" d-flex="true">
                                <input
                                    type="checkbox"
                                    id="exclude-basic-economy"
                                    value="Y"
                                    name="exclude-basic-economy"
                                    checked={selectedExcludeBasicEconomy === 'Y'}
                                    onChange={this.selectExcludeBasicEconomy}
                                />
                                <label htmlFor="exclude-basic-economy">
                                    <span className="d-block">&nbsp;{Lang.trans('engine.exclude_economy')}</span>
                                </label>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="styled-checkbox py-1" d-flex="true">
                                <input
                                    type="checkbox"
                                    id="exclude-nonrefundable-flights"
                                    value="Y"
                                    name="exclude-nonrefundable-flights"
                                    checked={selectedExcludeNonRefundable === 'Y'}
                                    onChange={this.selectExcludeNonRefundable}
                                />
                                <label htmlFor="exclude-nonrefundable-flights">
                                    <span className="d-block">&nbsp;{Lang.trans('engine.exclude_non_ref_flights')}</span>
                                </label>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="styled-checkbox py-1" d-flex="true">
                                <input
                                    type="checkbox"
                                    id="exclude-nonchangable-flights"
                                    value="Y"
                                    name="exclude-nonchangable-flights"
                                    checked={selectedExcludeNonChangable === 'Y'}
                                    onChange={this.selectExcludeNonChangable}
                                />
                                <label htmlFor="exclude-nonchangable-flights">
                                    <span className="d-block">&nbsp;{Lang.trans('engine.exclude_non_charge_flights')}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                )} */}
                    <div className="row gutter-0 border-top pt-2 align-items-center justify-content-center">
                        {/* <div className="col-12 col-md-12 col-lg-6 col-xl-4 d-flex align-self-center justify-content-center justify-content-md-start align-content-center partial-stay my-2">
                        <label className="switch theme-3 mb-0 align-self-center">
                            <input type="checkbox" checked={showPartStay} onChange={(e) => this.changePartStay(e)} />
                            <span className="slider round ml-0"></span>
                            <span className="sr-only black-text">I only need a hotel for part of my stay</span>
                        </label>
                        <div id="dyn_hotelPartial" className="pl-2 ml-2 d-inline-block align-self-center black-text">I only need a hotel for part of my stay</div>
                    </div> */}
                        <div className="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-5 my-2">
                            {/* <input id="" className="col-12 col-sm-6 bg-white py-3 font-weight-500 border" placeholder={Lang.trans('engine.promoCode')} value={promoCode} onChange={this.onPromoCodeChange} /> */}
                            <div className="row gutter-20">
                            {/* <div className="col-6">
                                <div className="element-container mb-0">
                                    <div className="date-picker-btn position-relative">
                                        <span className="text-label">{Lang.trans('engine.promoCode')}</span>
                                        <input
                                            className="w-100 h-100 py-0 pl-0 pb-1 pr-3"
                                            placeholder={Lang.trans('engine.enter_code')} 
                                            name="promoCode"
                                            onChange={this.onPromoCodeChange}
                                            // readOnly={!!((this.props.promoCode !== null))}
                                            value={promoCode}
                                        />
                                    </div>
                                </div>
                            </div> */}
                            <div className="col-12 text-center mb-2 mb-lg-0 mt-3">
                                <button type="submit" className="btn btn-primary btn-lg px-5 font-weight-600">
                                    <span className="">{Lang.trans('buttons.search')}</span>
                                </button>
                            </div>
                        </div>
                        </div>
                        
                        
                    </div>
                </form>
                {infantDetail && (
                    <AriaModal
                        onExit={this.closeInfantDetail}
                        initialFocus="#mdl-content"
                        aria-describedby="mdl-content"
                        titleId="mdl-title"
                        aria-labelledby="mdl-title"
                        dialogStyle={{ width: '1000px' }}
                        aria-modal="true"
                        verticallyCenter
                    >
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content modal p-4">
                                <h5 className="modal-title mb-4 primary-color font-weight-bold" id="mdl-title">
                                    {Lang.trans('engine_travelgenie.booking_an_infant')}
                                </h5>
                                <button type="button" onClick={this.closeInfantDetail} className="close close-lg position-absolute top-right p-0 m-0" aria-label="Close">
                                    <span className="pt-md-1 d-inline-block" aria-hidden="true">
                                        ×
                                    </span>
                                </button>
                                <div className="modal-main p-0" id="mdl-content">
                                    <div className="content">
                                        <p className="booking-infant">
                                        {Lang.trans('engine_travelgenie.booking_an_infant_pera')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AriaModal>
                )}
            </>
        );
    }
}

export default Dynamic;
